/* eslint-disable react/prop-types */
import "./Login.css";
import logoMetro from "../../../assets/images/logo_metromedellin.jpg";
import { Button, Typography, Card } from "antd";

const { Title, Paragraph } = Typography;

const LoginCognitoPage = ({ actionFuntion }) => {
  return (
    <div className="login-wrapper">
      {/* Panel izquierdo */}
      <div className="login-left-panel">
        <img src={logoMetro} alt="Metro Medellín" className="logo-img" />
        <Title level={3} style={{ color: "#fff", marginTop: 20 }}>
          Plataforma de gestión CISE
        </Title>
        <Paragraph style={{ color: "#ccc" }}>Plataforma de registro.</Paragraph>
      </div>

      {/* Panel derecho */}
      <div className="login-right-panel">
        <Card className="login-card" style={{ width: 360 }}>
          <Title level={4}>Inicia sesión</Title>
          <Paragraph style={{ marginBottom: 24 }}>
            Autentícate usando tu cuenta institucional del Directorio Activo.
          </Paragraph>

          <Button
            type="primary"
            block
            onClick={actionFuntion}
            style={{ backgroundColor: "#5FA82C", border: "none" }}
          >
            Iniciar sesión con Directorio Activo
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default LoginCognitoPage;
